module.exports = __webpack_public_path__ + "static/CardOfDarkness1-d84fd72a1b4065e86e7f5370dfb127fd.webp";